import React, { useState } from 'react';
import './OfficeHours.css';

const officeHours = [
  {
    id: 2,
    title: 'Divyesh 3081 OH',
    date: 'Monday, September 22',
    time: '1:15 – 2:15pm',
    meet: 'https://meet.google.com/nyh-zbcz-hmr',
  },
  {
    id: 1,
    title: 'Divyesh 3081 OH',
    date: 'Tuesday, September 16',
    time: '11:15am – 12:15pm',
    meet: 'https://meet.google.com/nyh-zbcz-hmr',
  },
];

export default function OfficeHours() {
  const [selectedOH, setSelectedOH] = useState(null);
  const [form, setForm] = useState({ name: '', email: '', concern: '' });

  const handleRequest = (oh) => {
    setSelectedOH(oh);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = `${form.name} will be attending Divyesh's office hours`;
    const body = `Office Hours Confirmation\n\nName: ${form.name}\nEmail: ${form.email}\nConcern: ${form.concern}\nDate/Time: ${selectedOH.date} at ${selectedOH.time}\nGoogle Meet: ${selectedOH.meet}\n\nThis is a confirmation for attending Divyesh's office hours.`;
    const mailto = `mailto:thiru063@umn.edu,${form.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailto;
  };

  return (
    <div className="office-hours-container">
      <h1>Office Hours</h1>
      {!selectedOH ? (
        <div className="oh-list">
          {officeHours.map((oh) => (
            <div key={oh.id} className="oh-card">
              <h2>{oh.title}</h2>
              <p>{oh.date} <br /> {oh.time}</p>
              <button onClick={() => handleRequest(oh)} className="request-btn">Request</button>
            </div>
          ))}
        </div>
      ) : (
        <form className="oh-form" onSubmit={handleSubmit}>
          <h2>Request Office Hours</h2>
          <p className="oh-details"><strong>{selectedOH.title}</strong></p>
          <p className="oh-details">{selectedOH.date} <br /> {selectedOH.time}</p>
          <label>Name:<input type="text" name="name" value={form.name} onChange={handleChange} required /></label>
          <label>Email:<input type="email" name="email" value={form.email} onChange={handleChange} required /></label>
          <label>Concern:<textarea name="concern" value={form.concern} onChange={handleChange} required /></label>
          <button type="submit" className="submit-btn">Send Confirmation Email</button>
          <button type="button" className="back-btn" onClick={() => setSelectedOH(null)}>Back</button>
        </form>
      )}
    </div>
  );
}
